import { render, staticRenderFns } from "./RolesForm.vue?vue&type=template&id=d77f1bc8&"
import script from "./RolesForm.vue?vue&type=script&lang=ts&"
export * from "./RolesForm.vue?vue&type=script&lang=ts&"
import style0 from "./RolesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports